import { Component, OnInit } from '@angular/core';
import { ClientesRelatoriosComFiltros, FiltrosClientesRelatorios } from '@app/pages/relatorios/clientes/clientes-relatorios';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ConsultasService } from '@app/services/consultas.service';
import { RelatorioService } from '@app/services/relatorio.service';
import { EstadoDoProcesso } from '../../../../models/estado-do-processo.model';

@Component({
  selector: 'app-clientes-filtros',
  templateUrl: './clientes-filtros.component.html',
  styleUrls: ['./clientes-filtros.component.scss']
})
export class ClientesFiltrosComponent implements OnInit {

  lstUnidades: IdDescricao[] = [];
  listaClientes: ClientesRelatoriosComFiltros[] = [];
  lstStatus: EstadoDoProcesso[];

  filtros: FiltrosClientesRelatorios;
  pesquisando = false;

  constructor(
    private consultasService: ConsultasService,
    private relatorioService: RelatorioService
  ) {
    this.filtros = {
      UnidadeId: '1',
      Opcao: 2
    };
  }

  ngOnInit() {
    this.consultasService
      .consultar('UNIDADE_S_RATEIO').toPromise()
      .then(data => this.lstUnidades = data);
    this.consultasService
      .consultar('ESTADODOPROCESSO').toPromise()
      .then(data => this.lstStatus = data);
  }

  pesquisar() {
    this.pesquisando = true;

    this.relatorioService
      .clientes(this.filtros)
      .toPromise()
      .then(data => {
        this.listaClientes = data;
        this.pesquisando = false;
      });
  }


}
